module.exports = __webpack_public_path__ + "static/media/wireless-red-quarter.952877cf.jpg";